import { LEAVE_STATUSES } from 'domain/shared/leave';
import { DefaultDropdownProps, Dropdown } from 'framework/form';

const LeaveStatusDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <Dropdown
      placeholder="Choose Leave Status"
      options={Object.entries(LEAVE_STATUSES).map(entry => {
        const [value, label] = entry;

        return {
          value,
          label,
        };
      })}
      label="Leave Status"
      {...props}
    />
  );
};

export default LeaveStatusDropdown;
